import { StoresMap } from '~domain/entities/StoresMap';
import { IStoresMapBounds } from '~interfaces/IStoresInterfaces';
export class StoresMapPannedUseCase {
    private storesMap: StoresMap;

    constructor(storesMap: StoresMap) {
        this.storesMap = storesMap;
    }

    public execute = async (bounds: IStoresMapBounds) => {
        this.storesMap.updateBounds(bounds);
    };
}
